export default __webpack_public_path__ + "static/media/F1.e2978c35.png";